import validator from 'validator';
import joi from 'joi';
import { VALID, INVALID } from './shared-constants';
export var parse = function parse(email) {
  var result = {
    valid: INVALID,
    email: null,
    formatted: null,
    error: {
      type: 'genericError',
      message: "Invalid email: ".concat(email)
    }
  };
  if (!email || !String(email || '').trim()) {
    result.error.type = 'length';
    result.error.message = 'Empty invalid email';
    return result;
  }
  if (!validator.isEmail(email.trim())) {
    return result;
  }
  var joiRes = joi.string().email({
    tlds: {
      allow: false
    }
  }).validate(email.trim());
  if (joiRes.error) {
    return result;
  }
  var normalizeOptions = {
    all_lowercase: true,
    gmail_remove_subaddress: true,
    outlookdotcom_remove_subaddress: true,
    yahoo_remove_subaddress: true,
    icloud_remove_subaddress: true
  };
  var normalizedEmail = validator.normalizeEmail(email.trim(), normalizeOptions);
  return {
    valid: VALID,
    email: email,
    formatted: normalizedEmail,
    error: {
      type: null,
      message: null
    }
  };
};
export var CONSTANTS = {
  VALID: VALID,
  INVALID: INVALID
};